/* eslint-disable max-len */
import { toastr } from 'react-redux-toastr';
import {
    pendingTask,
    begin,
    end,
} from 'react-redux-spinner';
import {
    UPDATE_UNAWARDED_SHIFTLINES_REPORT,
} from './unawardedShiftlinesReport.actions';
import { LOADING_END, LOADING_START } from '../loading';
import * as api from '../../Manager/services/api-endpoints';
import FileService from '../../services/FileService';
import i18n from '../../services/i18n';
import { ShiftDisplayType } from '../../Enums';

/**
 * @param {BidProfile.IScheduleTemplateItem[]} items
 * @returns {EmployeeBidProfile.IGroupedScheduleTemplateItems[]}
 */
const prepareTableItems = (items) => items.map((item, index) => {
    const weeklyHeight = Object.keys(item.maxDayPerWeek).map((x) => item.maxDayPerWeek[Number(x)]);
    /** @type {BidProfile.ISchedulePatternTemplateItem[][][]} */
    const shifts = [];
    item.schedulePatternTemplate.items.forEach((shift) => {
        const week = Math.floor((shift.day - 1) / 7);
        const dayOfWeek = (shift.day - 1) % 7;
        if (shifts[week] === undefined) {
            shifts[week] = [[], [], [], [], [], [], []];
        }

        shifts[week][dayOfWeek].push(shift);
    });
    return {
        groupId: '',
        quantity: 1,
        position: index,
        scheduleTemplateNameList: [item.schedulePatternTemplate.name],
        ...item,
        weeklyHeight,
        shifts,
        tableOrder: -1, // TODO : make these obsolete
        rowClassName: '', // TODO : make these obsolete
        approvedRow: true,
    };
});

/**
 * @param {string} profileId
 */
// eslint-disable-next-line import/prefer-default-export
export const loadUnawardedShiftlines = (profileId, searchQuery, pageIndex, pageSize) => /** @param {import('redux').Dispatch} dispatch */async (dispatch) => {
    try {
        dispatch({ type: LOADING_START, [pendingTask]: begin });
        const result = await api.getUnawardedShiftlines(profileId, searchQuery, pageIndex - 1, pageSize);
        if (result.status === 200) {
            const preparedShiftLines = prepareTableItems(result.data.unawardedShiftLines);
            return dispatch({
                type: UPDATE_UNAWARDED_SHIFTLINES_REPORT,
                payload: {
                    unawardedShiftlines: preparedShiftLines,
                    totalCount: result.data.totalCount,
                    shiftDisplayType: result.data.shiftDisplayType || ShiftDisplayType.ShiftLabel,
                },
            });
        }
        toastr.error(i18n.t('shiftBidding:toastr.fetchingUnawardedShiftlinesReport'), i18n.t('shiftBidding:toastr.failedToFetchUnawardedShiftlinesReport'));
        return Promise.reject();
    } catch (error) {
        toastr.error(i18n.t('shiftBidding:toastr.fetchingUnawardedShiftlinesReport'), error.response.data.Message);
        return Promise.reject(error);
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};

/**
 * @param {string} profileId
 * @param {string} searchQuery
 */
export const downloadReportAsCsv = (profileId, searchQuery) => /** @param {import('redux').Dispatch} dispatch */async (dispatch) => {
    try {
        dispatch({ type: LOADING_START, [pendingTask]: begin });
        const response = await api.DownloadUnawardedShiftlinesCsv(profileId, searchQuery);

        if (response.status === 200) {
            FileService.downloadContentInFile('UnawardedShiftlines', 'csv', response.data);
        } else {
            toastr.error(i18n.t('shiftBidding:toastr.downloadingCSVFile'), i18n.t('shiftBidding:toastr.failedToDownload'));
        }
    } catch (error) {
        toastr.error(i18n.t('shiftBidding:toastr.downloadingCSVFile'), error.response.data.Message);
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};
